import {
  isCashBackStatusWithLabel,
  statusTypeLabels,
} from '../../../myAccount/my-credits/helper/getCashBackLabels';
import {IBankAccountInfo} from '../api/getBankAccountInfo/getBankAccountInfo';
import {ICashBackDetails} from '../api/getCashBackCardDetail/getCashBackCardDetail';
import {CashBackStatus} from '../api/getCashBackCards/cashBackCards.types';
import {IStats} from '../components/StatsGrid';
import {
  calculateCashBackActiveCredit,
  calculateCashBackRestCredits,
  calculateCashBackUsedCredits,
} from './cashBackAmountAmountHelpers';

const generateInfoListData = (
  data: ICashBackDetails,
  accountData: IBankAccountInfo | undefined,
  onActiveCreditInfoClick: () => void,
): IStats[] => {
  const {amount, used_amount, reserved_amount, status} = data;

  const {iban_number} = accountData ?? {};

  const isWithdrawalRequested = status === CashBackStatus.RequestToWithdrawal;

  const hasStatusLabel = isCashBackStatusWithLabel(status);

  return [
    {
      title: 'مبلغ برداشت شده',
      value: calculateCashBackRestCredits(amount, used_amount, reserved_amount),
      show: isWithdrawalRequested,
      isPrice: true,
    },
    {
      title: 'شماره شبا مقصد',
      value: iban_number ? `IR ${iban_number}` : undefined,
      show: isWithdrawalRequested,
    },
    {
      title: 'کل اعتبار دریافت شده',
      value: amount,
      show: !isWithdrawalRequested,
      isPrice: true,
    },
    {
      title: 'اعتبار فعال',
      value: calculateCashBackActiveCredit(
        status,
        amount,
        used_amount,
        reserved_amount,
      ),
      show: !isWithdrawalRequested,
      isPrice: true,
      hasInfo: true,
      infoAction: onActiveCreditInfoClick,
    },
    {
      title: 'اعتبار استفاده شده',
      value: calculateCashBackUsedCredits(used_amount, reserved_amount),
      show: !isWithdrawalRequested,
      isPrice: true,
    },
    {
      title: 'وضعیت',
      value: hasStatusLabel ? statusTypeLabels[status] : undefined,
      show: hasStatusLabel,
      isPrice: false,
    },
  ];
};

export default generateInfoListData;
